import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "preview", "fallback", "save", "fileName"]

  connect() {
    this.saveTarget.hidden = true
  }

  choose(event) {
    const [file] = event.target.files
    if (!file) return

    this.fileNameTarget.textContent = file.name
    this.saveTarget.hidden = false

    const previewUrl = URL.createObjectURL(file)
    this.previewTarget.src = previewUrl
    this.previewTarget.classList.remove("hidden")
    this.fallbackTarget.classList.add("hidden")
    this.previewTarget.onload = () => URL.revokeObjectURL(previewUrl)
  }
}
